<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" lg="3" class="span-label">
              <span>Search any keyword</span>
              <v-text-field
                hide-details
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                block
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col
              cols="12"
              lg="2"
              v-if="$role.restricAccess($route.name, 'add')"
              class="mt-7"
              style="padding-top:5px;"
            >
              <v-btn
                block
                color="green_button"
                class="float-right btn-block"
                @click="modalForm()"
                >Add user</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.status`]="{ item }">{{
                  item.status == 1 ? "Active" : "Inactive"
                }}</template>

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn
                    color="info"
                    block
                    solo
                    single-line
                    dark
                    small
                    @click="findData(item.id)"
                  >
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="750px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update user</span>
            <span v-else>Create user</span>
          </v-card-title>

          <v-card-text>
            <v-row class="pt-6">
              <v-col cols="12" class="mt-n5 mb-n8">
                <v-switch
                  color="info"
                  dense
                  inset
                  v-model="form.status"
                  label="Status"
                  class="float-right"
                ></v-switch>
              </v-col>
              <!-- <v-col cols="12" lg="6" class="form-col">
                                <v-text-field dense solo single-line v-model="form.name" label="Fullname" :error-messages="formerror.name"></v-text-field>
                            </v-col> -->
              <v-col cols="12" lg="6" class="span-label">
                <span>Username</span>
                <v-text-field
                  hide-details
                  dense
                  class="regular-field"
                  v-model="form.username"
                  label="Username"
                  :error-messages="formerror.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span>Mobile number</span>
                <v-text-field
                  hide-details
                  dense
                  class="regular-field"
                  v-model="form.mobilenumber"
                  label="Mobile number"
                  :error-messages="formerror.mobilenumber"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="span-label">
                <span>Password</span>
                <v-text-field
                  hide-details
                  dense
                  class="regular-field"
                  v-model="form.password"
                  label="Password"
                  :error-messages="formerror.password"
                  type="text"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" lg="6" class="span-label">
                <span>User type</span>
                <v-select
                  :items="['Sub user']"
                  hide-details
                  dense
                  class="regular-field"
                  v-model="form.user_type"
                  label="User type"
                  :error-messages="formerror.user_type"
                ></v-select>
              </v-col> -->
              <v-col cols="12">
                <v-card flat>
                  <v-card-text>
                    <v-simple-table
                      class="custom-header-color table-bordered table-striped"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>
                              Menu
                            </th>
                            <th
                              width="12%"
                              v-for="(item, index) in $role.listRoles()"
                              :key="index"
                            >
                              {{ item.text }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in $role.listPages()"
                            :key="index"
                          >
                            <td>{{ item.text }}</td>
                            <th
                              v-for="(value, key) in $role.listRoles()"
                              :key="key"
                            >
                              <v-checkbox
                                v-model="
                                  form.use_role[item.value + '__' + value.text]
                                "
                              ></v-checkbox>
                            </th>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="actionButtons">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn color="red_button" @click="dialogForm = false"
                  >Back</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="updateData"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'delete')"
                  ><v-btn
                    color="delete_button"
                    class="float-right mr-3"
                    dark
                    :loading="isLoadingBtnDelete"
                    @click="deleteData(form.id)"
                    v-if="modalUpdate"
                    >Delete</v-btn
                  ></span
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      roleTab: null,
      dialogForm: false,
      modalprogressbar: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,

      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: false,
          searchable: false,
          align: " d-none",
        },
        // { text: 'Name', value: 'name', name: 'name', sortable: true, searchable: true},
        {
          text: "Username",
          value: "username",
          name: "username",
          sortable: true,
          searchable: true,
        },
        {
          text: "Mobile number",
          value: "mobilenumber",
          name: "mobilenumber",
          sortable: true,
          searchable: true,
        },
        {
          text: "Status",
          value: "status",
          name: "status",
          sortable: true,
          searchable: true,
        },
        {
          text: "User type",
          value: "user_type",
          name: "user_type",
          sortable: true,
          searchable: true,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          searchable: false,
          width: "10%",
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",

      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        use_role: {},
        user_type: "Sub user",
        status: 1,
        mobilenumber: "",
      }),
    };
  },
  methods: {
    modalForm(data) {
      this.formerror = {};
      this.form.reset();
      this.modalUpdate = false;
      this.dialogForm = true;
    },
    newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api() + "/agentportal/user")
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          //this.$Swal.fire("Success!", "Record has been successfully added.", "success");
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully added.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    findData(id) {
      this.formerror = {};
      this.form.reset();
      this.$axios
        .get(this.$_CONFIG.api() + "/agentportal/user/" + id)
        .then(({ data }) => {
          data.use_role = !data.use_role ? {} : data.use_role;
          this.form.fill(data);
          this.modalUpdate = true;
          this.dialogForm = true;
          this.form.status = parseInt(this.form.status);
        })
        .catch((error) => {
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api() + "/agentportal/user/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          //this.$Swal.fire("Updated!", "Record has been successfully updated.", "success");
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData() {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete all record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api() + "/agentportal/user/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            //this.$Swal.fire("Deleted!", "Record has been successfully deleted", "success");
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        reload: this.dt_reload,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/agentportal/user";

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
  },
  created() {
    this.getDataFromApi();
    // Echo.channel("reloaddatas").listen("ReloadDataEvent", (e) => {
    //     this.dt_reload++
    //     console.log('socket trigger');
    // });
  },
  mounted() {
    // console.log(this.$role.restricAccess(this.$route.name, 'delete'));
    // console.log(this.$role.listPages());
  },
};
</script>